import { render } from "./Whatsapp.vue?vue&type=template&id=255c1d16&scoped=true"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=255c1d16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255c1d16"]])

export default __exports__